import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiArrowRight } from 'react-icons/fi';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Optional: Auto-redirect after a few seconds
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container className="min-vh-100 d-flex align-items-center justify-content-center">
      <Row className="w-100 justify-content-center">
        <Col md={8} lg={6}>
          <Card className="text-center shadow-lg border-0">
            <Card.Body className="p-5">
              <div className="mb-4">
                <FiCheckCircle 
                  size={80} 
                  className="text-success mb-3" 
                />
                <h1 className="text-success mb-3">Payment Successful!</h1>
                <p className="text-muted fs-5 mb-4">
                  Thank you for your subscription. Your account has been upgraded successfully.
                </p>
              </div>

              <div className="bg-light rounded p-4 mb-4">
                <h5 className="mb-3">What's Next?</h5>
                <div className="text-start">
                  <div className="d-flex align-items-center mb-2">
                    <FiCheckCircle className="text-success me-2" />
                    <span>Your subscription is now active</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <FiCheckCircle className="text-success me-2" />
                    <span>All premium features unlocked</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <FiCheckCircle className="text-success me-2" />
                    <span>Invoice and receipt sent to your email</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <FiCheckCircle className="text-success me-2" />
                    <span>Start creating invoices and managing customers</span>
                  </div>
                </div>
              </div>

              <div className="d-grid gap-2">
                <Button 
                  variant="primary" 
                  size="lg"
                  onClick={() => navigate('/dashboard')}
                  className="d-flex align-items-center justify-content-center"
                >
                  Go to Dashboard <FiArrowRight className="ms-2" />
                </Button>
                <Button 
                  variant="outline-secondary"
                  onClick={() => navigate('/subscription')}
                >
                  View Subscription Details
                </Button>
              </div>

              <div className="mt-4 text-muted small">
                <p>Redirecting to dashboard in 5 seconds...</p>
                <p>
                  Need help? <a href="/contact" className="text-decoration-none">Contact Support</a>
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentSuccessPage;
